import LegislativnyMaterialListPage from './LegislativnyMaterialListPage';

export default LegislativnyMaterialListPage;
